// extracted by mini-css-extract-plugin
export default {"brandPromo":"QH-z","carousel":"RH-z"};